import { render, staticRenderFns } from "./HomeResidents.vue?vue&type=template&id=407f3b51&scoped=true&"
import script from "./HomeResidents.vue?vue&type=script&lang=js&"
export * from "./HomeResidents.vue?vue&type=script&lang=js&"
import style0 from "./HomeResidents.vue?vue&type=style&index=0&id=407f3b51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f3b51",
  null
  
)

export default component.exports